export default __webpack_public_path__ + "static/media/tablet-curology.26620894.jpg";